"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("./core");
const validation_1 = require("./validation");
const applicator_1 = require("ajv/dist/vocabularies/applicator");
const format_1 = require("ajv/dist/vocabularies/format");
const metadataVocabulary = ["title", "description", "default"];
const draft4Vocabularies = [
    core_1.default,
    validation_1.default,
    applicator_1.default(),
    format_1.default,
    metadataVocabulary,
];
exports.default = draft4Vocabularies;
//# sourceMappingURL=draft4.js.map